<img src="/assets/sdk/gelato-logo-black.svg" />
